import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import Layout from '../Components/Layout';
import 'react-toastify/dist/ReactToastify.css';

const SuppliersPage = () => {
    const [suppliers, setSuppliers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [editingSupplier, setEditingSupplier] = useState(null);
    const [deletingSupplier, setDeletingSupplier] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [showAddForm, setShowAddForm] = useState(false);
    const [formData, setFormData] = useState({
        username: '',
        firstname: '',
        lastname: '',
        company: '',
        paymentTerms: '',
        fobOrigin: '',
        fobDest: '',
        shippingAddress: '',
        isActive: ''
    });
    const [newSupplierData, setNewSupplierData] = useState({
        username: '',
        firstname: '',
        lastname: '',
        company: '',
        paymentTerms: '',
        fobOrigin: '',
        fobDest: '',
        shippingAddress: '',
        password: '',
        isActive: ''
    });
    const fromSelect = (v) => (v === "true" ? 1 : v === "false" ? 0 : null);
    const toSelect   = (v) => (v === 1 ? "true" : v === 0 ? "false" : "none");  

    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Format date helper function
    const formatDate = (dateString) => {
        if (!dateString || dateString === 'null' || dateString === 'undefined') {
            return 'No date available';
        }
        
        const date = new Date(dateString);
        
        if (isNaN(date.getTime())) {
            return `Invalid date: ${dateString}`;
        }
        
        const dateOptions = { day: 'numeric', month: 'long', year: 'numeric' };
        const timeOptions = { hour: 'numeric', minute: '2-digit', hour12: true };
        
        const formattedDate = date.toLocaleDateString('en-US', dateOptions);
        const formattedTime = date.toLocaleTimeString('en-US', timeOptions);
        
        return `${formattedDate} ${formattedTime}`;
    };

    useEffect(() => {
        IsAdmin();
        fetchSuppliers();
    }, []);
    
    const IsAdmin = async () => {
        try {
            const response = await axios.get('manage/check-role');
            if(response.data !== "Admin") {
                window.location.href = "/login";
            }
        } catch (error) {
            window.location.href = "/login";
        }
    }

    // Fetch all suppliers
    const fetchSuppliers = async () => {
        try {
            const response = await axios.get('manage/suppliers');
            setSuppliers(response.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching suppliers:', error);
            toast.error('Failed to fetch suppliers');
            setLoading(false);
        }
    };

    // Handle edit button click
    const handleEdit = (supplier) => {
        console.log(supplier);
        setEditingSupplier(supplier.id);
        setFormData({
            username: supplier.username || '',
            firstname: supplier.firstname || '',
            lastname: supplier.lastname || '',
            company: supplier.company || '',
            paymentTerms: supplier.paymentTerms || '',
            fobOrigin: supplier.fobOrigin || '',
            fobDest: supplier.fobDest || '',
            shippingAddress: supplier.shippingAddress || '',
            isActive: supplier.isActive || 'false'
        });
    };

    // Handle update
    const handleUpdate = async (supplierId) => {
        if (!formData.username.trim()) {
            toast.error('Username is required');
            return;
        }

        try {
            await axios.put(`manage/suppliers/${supplierId}`, formData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            toast.success('Supplier updated successfully');
            setEditingSupplier(null);
            fetchSuppliers();
        } catch (error) {
            console.error('Error updating supplier:', error);
            toast.error('Failed to update supplier');
        }
    };

    // Handle delete
    const handleDelete = async (supplierId) => {
        try {
            const response = await axios.delete(`manage/suppliers/${supplierId}`);
            
            if(response.code === "ERR_BAD_REQUEST") {
                toast.error(response.response.data.detail);
            } else {
                toast.success('Supplier deleted successfully');
                setDeletingSupplier(null);
                fetchSuppliers();
            }
        } catch (error) {
            console.error('Error deleting supplier:', error);
            // Show the specific error message from backend
            const errorMessage = error.response?.data?.detail || 'Failed to delete supplier';
            toast.error(errorMessage);
            setDeletingSupplier(null);
        }
    };

    // Handle add new supplier
    const handleAddSupplier = async () => {
        try {
            await axios.post('manage/suppliers', newSupplierData);
            toast.success('Supplier added successfully');
            setShowAddForm(false);
            setNewSupplierData({
                username: '',
                firstname: '',
                lastname: '',
                company: '',
                paymentTerms: '',
                fobOrigin: '',
                fobDest: '',
                shippingAddress: '',
                password: ''
            });
            fetchSuppliers();
        } catch (error) {
            console.error('Error adding supplier:', error);
            toast.error('Failed to add supplier');
        }
    };

    // Filter suppliers based on search
    const filteredSuppliers = suppliers.filter(supplier => 
        (supplier.company && supplier.company.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (supplier.firstname && supplier.firstname.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (supplier.lastname && supplier.lastname.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (supplier.username && supplier.username.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    return (
        <Layout>
            <div style={{ height: 'calc(100vh - 70px)', overflow: 'auto', padding: '20px 0px' }}>
                <div className="container-fluid">
                    {/* Search and Add Button */}
                    <div className="row mb-4">
                        <div className="col-md-6">
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search suppliers..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    style={{ height: '45px' }}
                                />
                                <span className="input-group-text">
                                    <i className="ti-search"></i>
                                </span>
                            </div>
                        </div>
                        <div className="col-md-6 text-end">
                            <button 
                                className="btn btn-primary"
                                onClick={() => setShowAddForm(true)}
                                style={{ height: '45px', padding: '0 24px' }}
                            >
                                <i className="ti-plus me-2"></i>Add New Supplier
                            </button>
                        </div>
                    </div>

                    {/* Add Supplier Form */}
                    {showAddForm && (
                        <div className="card mb-4" style={{ border: '1px solid #e5e7eb' }}>
                            <div className="card-header" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e5e7eb' }}>
                                <h5 className="mb-0">Add New Supplier</h5>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label>Company Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={newSupplierData.company}
                                            onChange={(e) => setNewSupplierData({...newSupplierData, company: e.target.value})}
                                            style={{ height: '45px' }}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>Email</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            value={newSupplierData.username}
                                            onChange={(e) => setNewSupplierData({...newSupplierData, username: e.target.value})}
                                            style={{ height: '45px' }}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>First Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={newSupplierData.firstname}
                                            onChange={(e) => setNewSupplierData({...newSupplierData, firstname: e.target.value})}
                                            style={{ height: '45px' }}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>Last Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={newSupplierData.lastname}
                                            onChange={(e) => setNewSupplierData({...newSupplierData, lastname: e.target.value})}
                                            style={{ height: '45px' }}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>Password</label>
                                        <input
                                            type="password"
                                            autoComplete="new-password"
                                            className="form-control"
                                            value={newSupplierData.password}
                                            onChange={(e) => setNewSupplierData({...newSupplierData, password: e.target.value})}
                                            style={{ height: '45px' }}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>Payment Terms</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={newSupplierData.paymentTerms}
                                            onChange={(e) => setNewSupplierData({...newSupplierData, paymentTerms: e.target.value})}
                                            style={{ height: '45px' }}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>FOB Origin</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={newSupplierData.fobOrigin}
                                            onChange={(e) => setNewSupplierData({...newSupplierData, fobOrigin: e.target.value})}
                                            style={{ height: '45px' }}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>FOB Destination</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={newSupplierData.fobDest}
                                            onChange={(e) => setNewSupplierData({...newSupplierData, fobDest: e.target.value})}
                                            style={{ height: '45px' }}
                                        />
                                    </div>
                                    <div className="col-12 mb-3">
                                        <label>Shipping Address</label>
                                        <textarea
                                            className="form-control"
                                            rows="2"
                                            value={newSupplierData.shippingAddress}
                                            onChange={(e) => setNewSupplierData({...newSupplierData, shippingAddress: e.target.value})}
                                        />
                                    </div>
                                </div>
                                <div className="mt-3">
                                    <button className="btn btn-success me-2" onClick={handleAddSupplier}>
                                        <i className="ti-check me-1"></i>Save Supplier
                                    </button>
                                    <button className="btn btn-secondary" onClick={() => setShowAddForm(false)}>
                                        <i className="ti-close me-1"></i>Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Suppliers Table */}
                    <div className="card" style={{ border: '1px solid #e5e7eb' }}>
                        <div className="card-body p-0">
                            {loading ? (
                                <div className="text-center p-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden"></span>
                                    </div>
                                </div>
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-hover mb-0">
                                        <thead style={{ backgroundColor: '#f8f9fa' }}>
                                            <tr>
                                                <th style={{ padding: '15px' }}>Company</th>
                                                <th>Contact Name</th>
                                                <th>Email</th>
                                                <th>Payment Terms</th>
                                                <th>Status</th>
                                                <th>Ingredients</th>
                                                <th>Last Activity</th>
                                                <th>Last Activity By</th>
                                                <th className="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredSuppliers.map(supplier => (
                                                <tr key={supplier.id}>
                                                    <td style={{ padding: '15px' }}>
                                                        {editingSupplier === supplier.id ? (
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={formData.company}
                                                                onChange={(e) => setFormData({...formData, company: e.target.value})}
                                                            />
                                                        ) : (
                                                            <strong>{supplier.company || 'N/A'}</strong>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {editingSupplier === supplier.id ? (
                                                            <div className="d-flex gap-2">
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm"
                                                                    value={formData.firstname}
                                                                    onChange={(e) => setFormData({...formData, firstname: e.target.value})}
                                                                    placeholder="First"
                                                                />
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm"
                                                                    value={formData.lastname}
                                                                    onChange={(e) => setFormData({...formData, lastname: e.target.value})}
                                                                    placeholder="Last"
                                                                />
                                                            </div>
                                                        ) : (
                                                            `${supplier.firstname || ''} ${supplier.lastname || ''}`
                                                        )}
                                                    </td>
                                                    <td>
                                                        {editingSupplier === supplier.id ? (
                                                            <input
                                                                type="email"
                                                                className="form-control form-control-sm"
                                                                value={formData.username}
                                                                onChange={(e) => setFormData({...formData, username: e.target.value})}
                                                            />
                                                        ) : (
                                                            supplier.username
                                                        )}
                                                    </td>
                                                    <td>
                                                        {editingSupplier === supplier.id ? (
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={formData.paymentTerms}
                                                                onChange={(e) => setFormData({...formData, paymentTerms: e.target.value})}
                                                            />
                                                        ) : (
                                                            supplier.paymentTerms || 'N/A'
                                                        )}
                                                    </td>
                                                    <td>
                                                        {editingSupplier === supplier.id ? (
                                                            <select
                                                                className="form-control"
                                                                value={
                                                                    formData.isActive === null || formData.isActive === undefined 
                                                                        ? "none" 
                                                                        : String(formData.isActive)
                                                                }
                                                                onChange={(e) => {
                                                                    const value = e.target.value === "none" 
                                                                        ? null 
                                                                        : e.target.value === "true";
                                                                    setFormData({...formData, isActive: value});
                                                                }}
                                                            >
                                                                <option value="none">Select Status</option>
                                                                <option value="true">Active</option>
                                                                <option value="false">Inactive</option>
                                                            </select>
                                                        ) : (
                                                            supplier.isActive === null || supplier.isActive === undefined
                                                                ? "Not Set" 
                                                                : supplier.isActive 
                                                                    ? "Active" 
                                                                    : "Inactive"
                                                        )}

                                                    </td>
                                                    <td>{supplier.ingredients_count || 0}</td>
                                                    <td>{supplier.last_activity ? formatDate(supplier.last_activity) : '-'}</td>
                                                    <td>{supplier.last_activity_by || '-'}</td>
                                                    <td className="text-center">
                                                        {editingSupplier === supplier.id ? (
                                                            <>
                                                                <button 
                                                                    className="btn btn-sm btn-success me-1"
                                                                    onClick={() => handleUpdate(supplier.id)}
                                                                >
                                                                    <i className="ti-check"></i>
                                                                </button>
                                                                <button 
                                                                    className="btn btn-sm btn-secondary"
                                                                    onClick={() => setEditingSupplier(null)}
                                                                >
                                                                    <i className="ti-close"></i>
                                                                </button>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <i className="ti-pencil pointer" style={{marginRight: "20px", color:'#0c26f5'}}  onClick={() => handleEdit(supplier)}></i>
                                                                
                                                               
                                                                {deletingSupplier === supplier.id ? (
                                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                ) : (
                                                                    <i className="ti-trash pointer" style={{color:'#f00'}} onClick={() => setDeletingSupplier(supplier.id)} disabled={deletingSupplier === supplier.id}></i>
                                                                )}
                                                            </>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Delete Confirmation Modal */}
                    {deletingSupplier && (
                        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Confirm Delete</h5>
                                    </div>
                                    <div className="modal-body">
                                        Are you sure you want to delete this supplier? This action will permanently remove all associated data and cannot be undone.
                                    </div>
                                    <div className="modal-footer">
                                        <button 
                                            className="btn btn-danger"
                                            onClick={() => handleDelete(deletingSupplier)}
                                        >
                                            Delete
                                        </button>
                                        <button 
                                            className="btn btn-secondary"
                                            onClick={() => setDeletingSupplier(null)}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Supplier count display */}
                    {filteredSuppliers.length > 0 && (
                        <div className="mt-3">
                            <small className="text-muted">
                                Showing {filteredSuppliers.length} of {suppliers.length} suppliers
                            </small>
                        </div>
                    )}
                </div>
            </div>
            <ToastContainer />
        </Layout>
    );
};

export default SuppliersPage;